import React from 'react';
import ProgressLabel from '../ProgressLabel';

const DoneLabel = () => (
    <ProgressLabel text="Done" color="green" />
);

export default DoneLabel;
